module.exports = __webpack_public_path__ + "static/media/webfont.a43b0344.eot";